import { AccountType } from "../shared/types/accounts";
import { Post } from "../shared/types/post";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const ngDeps = {
  $rootScope: {
    go(state: object) {
      return Promise.resolve(state);
    },
  },
} as INgDeps;

export function injectNgDeps(deps: object) {
  Object.assign(ngDeps, deps);
}

export function getNgDep(dep: keyof INgDeps) {
  if (!ngDeps[dep]) {
    return null;
  }
  return ngDeps[dep];
}

export default ngDeps;

interface INgDeps {
  $rootScope: {
    user: {
      timezone?: string;
    };
    go: (state: object) => Promise<object>;
    shuffleQueuedPosts?: (accountIds: string[], form: unknown) => void;
    openModal: (data: { templateUrl: string; backdrop?: string }) => void;
    accountsMap: Record<string, AccountType>;
    accounts: AccountType[];
  };
  scheduleService: IScheduleService;
  postService: IPostService;
  $http: {
    get: (url: string, config?: any) => Promise<any>;
    post: (url: string, data?: any, config?: any) => Promise<any>;
  };
  collaborationService: {
    updatePostStatusKey: (
      postIds: string[],
      postType: string,
      key: string
    ) => Promise<void>;
  };
}

interface IScheduleService {
  findPosts(params: any): Promise<any>;
  findCalendarPosts(params: any): any;
  findLatestPosts(params: any): Promise<any>;
  findArchives(params: any): Promise<any>;
  findActive(page: number, pageSize: number, accountIds: any[]): Promise<any>;
  findArchived(
    page: number,
    pageSize: number,
    accountIds: any[],
    params?: any
  ): Promise<any>;
  findDrafts(
    page: number,
    pageSize: number,
    accountIds: any[],
    params?: any
  ): Promise<any>;
  searchDrafts(accountIds: any[], searchText: string): Promise<any>;
  findActiveByTime(accountIds: any[]): Promise<any>;
  makeSchedule(post: any): any;
  normaliseComments(post: any): any;
  normaliseTags(tags: any): any[];
  createPost(post: Post, actionType?: string): Post;
  update(id: string, schedule: any): Promise<any>;
  savePost(post: any): Promise<any>;
  clearSchedule(accountId: string): Promise<any>;
  copySchedule(sourceId: string, destinationId: string): Promise<any>;
  moveToQueue(post: any): Promise<any>;
  moveToSchedule(post: any): Promise<any>;
  updatePost(post: any): Promise<any>;
  updateRedirectUrl(post: any): Promise<any>;
  updateCalendarSchedule(
    id: string,
    schedule: any,
    hideCalendarDialog: boolean
  ): Promise<any>;
  moveCalendarPost(id: string, post: any, data: any): Promise<any>;
  schedulesOverlap(schedules: any[]): [number, number] | undefined;
  create(posts: any, uploader: any, suppress?: boolean): Promise<any>;
  cancel(id: string): Promise<any>;
  findById(id: string): Promise<any>;
  remove(id: string): Promise<any>;
  removeFromQueue(id: string): Promise<any>;
  moveToDraft(id: string, queued: boolean): Promise<any>;
}

interface IPostService {
  getNext15Min(): any;
  cleanPost(schedule: any): any;
  draft: {
    update(draft: Post, msg?: string): Promise<unknown>;
    queue(post: Post): Promise<unknown>;
    schedule(draft: Post): Promise<unknown>;
    draft(draft: Post): Promise<unknown>;
  };
  schedule: {
    update(schedule: Post): Promise<unknown>;
    queue(post: Post): Promise<unknown>;
    draft(post: Post): Promise<unknown>;
    schedule(post: Post): Promise<unknown>;
  };
  queue: {
    update(schedule: Post, stChg?: any): Promise<unknown>;
    draft(post: Post): Promise<unknown>;
    schedule(post: Post): Promise<unknown>;
    queue(post: Post): Promise<unknown>;
  };
  validatePost(post: Post): string | undefined;
  validateForm(form: any): string | undefined;
}
